import { render } from "./Concept_page_en.vue?vue&type=template&id=2e6d8838&scoped=true"
import script from "./Concept_page_en.vue?vue&type=script&lang=js"
export * from "./Concept_page_en.vue?vue&type=script&lang=js"

import "./Concept_page_en.vue?vue&type=style&index=0&id=2e6d8838&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2e6d8838"

export default script